import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TPostContentBeforeAfterGalleryReset, EPostContentBeforeAfterGalleryActionType } from './types';

export const postContentBeforeAfterGalleryReset: () => TPostContentBeforeAfterGalleryReset =
  actionGenerator<EPostContentBeforeAfterGalleryActionType.Reset>(EPostContentBeforeAfterGalleryActionType.Reset);
